import React from 'react';
import styled from 'styled-components/macro';
import { LinkStyled } from '../../../../components/typography';
import { FieldComponent } from './FieldComponent';
import FormIcon from './FormIcon';
import { BsFillPlusCircleFill } from '../../../../components/Icons';

const AddLink = styled(LinkStyled)`
  display: block;
  margin-top: 10px;
  color: ${({ theme }) => theme.colors.colorBlue};

  svg {
    font-size: 14px;
    position: relative;
    top: 2px;
  }

  &:hover {
    color: ${({ theme }) => theme.hoverColors.colorBlue};
    text-decoration: underline;
  }
`;

export default class ExtraPhonenumbersField extends React.Component {
  onAddPhonenumber = () => {
    const value = this.safeValues();
    const { onChange } = this.props;
    onChange({ target: { value: [...value, ''] } });
  }

  onRemovePhonenumber(index) {
    const { onChange, value } = this.props;
    onChange({ target: { value: value.length === 1 ? undefined : value.filter((v, i) => i !== index) } });
  }

  onChangePhonenumber = (index, newValue) => {
    const { onChange, value } = this.props;
    onChange({ target: { value: value.map((v, i) => (i === index ? newValue : v)) } });
  }

  safeValues() {
    const { value } = this.props;
    return value || [];
  }

  render() {
    const value = this.safeValues();
    return (
      <React.Fragment>
        {value.map(
          (v, i) => (
            <FieldComponent
              onChange={({ target: { value: newValue } }) => this.onChangePhonenumber(i, newValue)}
              value={v}
              onRemove={() => this.onRemovePhonenumber(i)}
              icon={<FormIcon phone />}
            />
          ),
        )}
        {value.length < 2 && (
          <AddLink action noStyle onClick={this.onAddPhonenumber}>
            Tilføj ekstra telefonnummer <BsFillPlusCircleFill />
          </AddLink>
        )}
      </React.Fragment>
    );
  }
}
